export const SvgLanguage = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.7849 15.4167H16.5468M11.7849 15.4167L10.8325 17.5M11.7849 15.4167L14.1659 10L16.5468 15.4167M16.5468 15.4167L17.4992 17.5"
      stroke="#1B2559"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66748 2.5L7.08415 3.75"
      stroke="#1B2559"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2.5 4.58313H11.6667" stroke="#1B2559" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M4.16748 6.66687C4.16748 6.66687 4.91311 9.27558 6.77715 10.7248C8.64115 12.1741 11.6675 13.3335 11.6675 13.3335"
      stroke="#1B2559"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 4.58313C10 4.58313 9.25437 8.00705 7.39033 9.90921C5.52633 11.8114 2.5 13.3331 2.5 13.3331"
      stroke="#1B2559"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
